export default __webpack_public_path__ + "static/media/google360.8df06dc6.png";